import { Label } from "reactstrap";
import { Avatar, Tooltip } from "antd";
import store from "../stores/StoreRoot";

function AvatarSingle(props) {
  function getCollaboratorName(email) {
    return email;
  }

  return (
    <Tooltip
      title={getCollaboratorName(props.email)}
      // placement="topLeft"
      zIndex={115000}
      color={store.colors.colorTooltip}
    >
      <Avatar
        key={props.email}
        size="small"
        style={{
          backgroundColor: store.main.getUserColor(props.email),
          alignItems: "center",
        }}
      >
        <Label
          style={{
            fontSize: 9,
            margin: 0,
            verticalAlign: 2,
            marginTop: -2,
            marginLeft: 0,
          }}
        >
          {props.email.replace(".", "").substring(0, 2).toUpperCase()}
        </Label>
      </Avatar>
    </Tooltip>
  );
}

export default AvatarSingle;
